import React, { Component, ErrorInfo, FunctionComponent } from 'react';
import logError from 'app/scripts/debug/log-error.coffee';

import { forTemplate } from 'app/common/lib/util/i18n';
const format = forTemplate('error');

import { ErrorDetails } from './ErrorDetails';

export interface CaughtError {
  error: Error;
  info: ErrorInfo;
}

export interface ErrorHandlerProps {
  caughtError: CaughtError;
}

export const DefaultErrorHandler: FunctionComponent<ErrorHandlerProps> = ({
  caughtError,
}) => (
  <div style={{ padding: 20 }}>
    <h3>
      <span style={{ color: '#DE350B', marginRight: 10 }}>
        {format('global-unhandled')}
      </span>
    </h3>
    <ErrorDetails caughtError={caughtError} />
  </div>
);

interface ErrorBoundaryProps {
  errorHandlerComponent?: FunctionComponent<ErrorHandlerProps>;
}

interface ErrorBoundaryState {
  caughtError: CaughtError | null;
}

export class ErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  state = {
    caughtError: null,
  };

  componentDidCatch(error: Error, info: ErrorInfo) {
    // We want to log the error so that it doesn't get swallowed. In the dev
    // environment this will log to the console. In production this will also
    // log to Sentry.
    logError(error, 'ErrorBoundary.tsx', 0, 0, {
      fromGlobalErrorBoundary: true,
    });

    this.setState({
      caughtError: { error, info },
    });
  }

  render() {
    const { caughtError } = this.state;

    if (caughtError) {
      const ErrorHandlerComponent =
        this.props.errorHandlerComponent || DefaultErrorHandler;

      return <ErrorHandlerComponent caughtError={caughtError} />;
    }

    return this.props.children;
  }
}
